import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './tokenlyglobal.css';

const Reviews = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const testimonialData = [
        {
            id: 1,
            name: "Priya Sharma",
            role: "Patient",
            gender: "female",
            content: "Tokenly has revolutionized how I book doctor appointments. No more long queues or waiting times. The token system is so efficient and user-friendly!"
        },
        {
            id: 2,
            name: "Rahul Verma",
            role: "Software Engineer",
            gender: "male",
            content: "As a busy professional, Tokenly saves me hours every week. I can book appointments instantly and get real-time updates. Truly a game-changer for healthcare in India."
        },
        {
            id: 3,
            name: "Anjali Patel",
            role: "Mother of Two",
            gender: "female",
            content: "The digital token system is brilliant! I love how I can track my queue number and estimated waiting time. Tokenly made healthcare accessible and convenient."
        },
        {
            id: 4,
            name: "Vikram Reddy",
            role: "Senior Citizen",
            gender: "male",
            content: "Tokenly's interface is so intuitive. Booking doctor appointments has never been easier. The token management system ensures I never miss my turn. Highly recommended!"
        }
    ];

    const nextSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === testimonialData.length - 1 ? 0 : prevIndex + 1
        );
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? testimonialData.length - 1 : prevIndex - 1
        );
    };

    const getVisibleCards = () => {
        const cards = [];
        for (let i = 0; i < 3; i++) {
            const index = (currentIndex + i) % testimonialData.length;
            cards.push({ ...testimonialData[index], pos: i });
        }
        return cards;
    };

    return (
        <section className="reviews-section overflow-hidden">
            <div className="container">
                <div className="text-center mb-5">
                    <span className="badge bg-success bg-opacity-10 text-success px-3 py-2 rounded-pill fw-bold mb-3">TESTIMONIALS</span>
                    <h2 className="display-5 fw-bold text-dark">What Our Clients Say</h2>
                    <p className="lead text-muted">Join thousands of happy users who trust Tokenly</p>
                </div>

                <div className="position-relative px-lg-5">
                    <div className="row g-4 align-items-stretch">
                        {getVisibleCards().map((client) => (
                            <div className="col-lg-4 col-md-6" key={client.id}>
                                <div className={`review-card-modern ${client.pos === 1 ? 'active-card' : 'inactive-card'}`}>
                                    <div className="quote-mark">
                                        <i className="fa-solid fa-quote-right"></i>
                                    </div>

                                    <div className="review-content">
                                        "{client.content}"
                                    </div>

                                    <div className="client-profile-box">
                                        <div className="client-avatar">
                                            <i className={`fas fa-${client.gender === 'male' ? 'user' : 'user-nurse'}`}></i>
                                        </div>
                                        <div className="client-info">
                                            <h6>{client.name}</h6>
                                            <span>{client.role}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    <button
                        className="review-nav-btn prev d-none d-lg-flex"
                        onClick={prevSlide}
                    >
                        <i className="fas fa-chevron-left"></i>
                    </button>

                    <button
                        className="review-nav-btn next d-none d-lg-flex"
                        onClick={nextSlide}
                    >
                        <i className="fas fa-chevron-right"></i>
                    </button>
                </div>

                <div className="d-lg-none d-flex justify-content-center gap-3 mt-4">
                    <button className="btn btn-outline-success rounded-circle" onClick={prevSlide}>
                        <i className="fas fa-chevron-left"></i>
                    </button>
                    <button className="btn btn-outline-success rounded-circle" onClick={nextSlide}>
                        <i className="fas fa-chevron-right"></i>
                    </button>
                </div>
            </div>
        </section>
    );
};

export default Reviews;
